import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';

export const overallPerformanceRectangle: ShapeProps = {
  shapeName: 'rect',
  options: {
    fill: {
      color: theme.colors.darkGray,
      transparency: 25,
    },
    line: {
      color: theme.colors.inmarketGreen,
      width: 1,
    },
    h: 4.83,
    w: 3.34,
    x: 0.69,
    y: 1.99,
  },
};

export const dimensionBlueRectangle: ShapeProps = {
  shapeName: 'rect',
  options: {
    fill: {
      color: theme.colors.blue,
    },
    h: 0.72,
    w: 8.36,
    x: 4.35,
    y: 1.99,
  },
};

export const dimensionNameRectangle = (
  options?: ShapeProps['options']
): ShapeProps => ({
  shapeName: 'rect',
  options: {
    fill: {
      color: theme.colors.inmarketGreen,
      transparency: 86,
    },
    ...options,
  },
});

export const dimensionLine = (options?: ShapeProps['options']): ShapeProps => ({
  shapeName: 'line',
  options: {
    line: {
      color: theme.colors.white,
      width: 1,
    },
    h: 0,
    w: 2.27,
    ...options,
  },
});
